import Image from 'next/image'

import { getFullName } from '@/_lib/utils'
import { IEmployee, IEmployeeReduced } from '@/_types'

export default function ATeamMemberCardHeader({
	employee
}: {
	employee: IEmployee | IEmployeeReduced
}) {
	return (
		<div className='employee__header flex flex-col items-center'>
			{employee.photo?.url ? (
				<div className='employee__header__photo relative aspect-square w-full max-w-[240px]'>
					<Image
						src={employee.photo?.url}
						alt={getFullName(employee)}
						height={240}
						width={240}
						quality={75}
						className='object-cover rounded-full w-full h-full'
						unoptimized={true}
					/>
				</div>
			) : (
				<div className='employee__header__photo aspect-square object-cover rounded-full w-full max-w-[240px] bg-gray-300'></div>
			)}

			<p className='employee__header__name my-1 mt-4 text-base'>{getFullName(employee)}</p>
			<p className='employee__header__position text-xs font-light min-h-[35px] mb-4'>
				{employee.position}
			</p>
		</div>
	)
}
